exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.leftBox[data-v-2a548a55] {\n    width: 100%;\n    margin-top: 0;\n}\n.leftBox .bannerBox[data-v-2a548a55] {\n      width: 100%;\n      height: auto;\n}\n.rightBox[data-v-2a548a55] {\n    display: none;\n}\n}\n", ""]);

